import clickOutside from "./click-outside.js";
import numericOnly from "./numeric-only.js";
import wrapElement from "./wrap-element.js";

export default {
  clickOutside,
  numericOnly,
  wrapElement,
};
